/* ------------------------------------------------------------------------------
@name: SweetAlert
--------------------------------------------------------------------------------- */

const SweetAlert = (() => {
  const handleRunSweetAlert = (message, status = "success") => {
    switch (status) {
      case "warning":
        swal({
          title: "Warning!",
          text: message,
          type: "warning",
          confirmButtonClass: "btn btn-warning",
          timer: 3000,
        });
        break;
      case "error":
        swal({
          title: "Error!",
          text: message,
          type: "error",
          confirmButtonClass: "btn btn-danger",
          timer: 3000,
        });
        break;

      case "confirm":
        swal({
          title: "Are you sure?",
          text: message,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
          confirmButtonClass: "btn btn-success",
          cancelButtonClass: "btn btn-danger m-l-10",
          buttonsStyling: false,
        });
      default:
        swal({
          title: "Success!",
          text: message,
          type: "success",
          confirmButtonClass: "btn btn-custom",
          timer: 3000,
        });
        break;
    }
  };

  return {
    config: handleRunSweetAlert,
  };
})();

export default SweetAlert;
